export const environment = {
  rememberMeKey: 'MW_RM_K_D',
  base_url:'https://trackmotor.dynamicwebsite.co.in/mindbase-dev-userapi/', // webDev
  // base_url:'http://localhost:6003/', // webDev
  // slugVerifyUrl: 'https://trackmotor.dynamicwebsite.co.in/jp/mindbase/dev/prepbase-user/web-dev/',
  core_url: 'https://trackmotor.dynamicwebsite.co.in/mindbase-dev-userapi/',
  // core_url: 'http://localhost:6003/',
  image_url: 'https://trackmotor.dynamicwebsite.co.in/mindbase-dev/admin/media/uploadFile',
  storageKey: 'MW_ST_K_D',
  refreshStorageKey: 'MW_ST_K_D_RT',
  sentryDsn : 'https://961eec0155ef2a363c99e2805da0580a@o4512168678195200.ingest.de.sentry.io/4512169478914129',
  sentryEnvironment: 'dev',
  refreshTokenIntervalMs: 60 * 60 * 1000, // 10 min — 5-min safety margin before the 15-min access token expires
  stripePublishKey: 'pk_test_51TynCnCsryn78ddE2MWIeZlbDIdMV1ZIFhZAuOEFWfTVxrfZcGmWKtcJKFTTPGJqLADnV6u31huPvtPtXhNGiOrE00UOOsqI8B',
  // socket_url: 'https://mindbasesocketapi.appgrowthcompany.com/',
   //socket_url: 'http://localhost:6002/',
  socket_url: 'https://dev-socket.dynamicwebsite.co.in/',
  gClientId: '443733978916-cqcj9gsr1p92dr991s6khp8p6alslcfn.apps.googleusercontent.com',
  gScopes: 'https://www.googleapis.com/auth/calendar',
  gDiscoverDoc: 'https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest',
  facebookAppId: '1367776671040777',
  appleAppId: 'com.mindbase.apple',
  langKey: 'lang',
  essayAutoSaveIntervalMs: 60_000,
  firebaseConfig: {
    apiKey: 'AIzaSyA74yJXmt34C2E_yyTQOgwMlH12O90rS9w',
    authDomain: 'prepbase-76b91.firebaseapp.com',
    projectId: 'prepbase-76b91',
    storageBucket: 'prepbase-76b91.firebasestorage.app',
    messagingSenderId: '181364161362',
    appId: '1:181364161362:web:55962752a843c55a81d88b',
    measurementId: 'G-GTENSLC3WN',
    vapidKey: 'BAeAjs2pkYIY9TwQfEw6394Sf1-drYjtBpqmXfxj38au1sEkS-TWxUQ35lgn2AI5XlMBshcUjY6snJIAyR1mnCw'
  }
};
